export function formatTimestamp(timestamp){
    try {
        const month = ["January","February","March","April","May","June","July","August","September","October","November","December"];
        const date = new Date(timestamp);
        return `${month[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`
    } catch (error) {
        return error;
    }
}